module.exports = __webpack_public_path__ + "static/media/pizza_t.e15b38a8.png";